import styled from '@emotion/styled';

const NoFieldName = styled('span')(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontWeight: 400,
}));

export default NoFieldName;
